module.exports = __webpack_public_path__ + "img/delano_0.db2134ee.webp";